import { eff } from "@/core/utils/effect-ts-abbr";
import { EnumeratorFilterItemDto } from "@/shared/api-contract/api-contract";
import { watchEffect } from "vue";
import { Emit, Model, Prop, Vue } from "vue-property-decorator";

export class EnumCheckboxList extends Vue {
    @Model("modelValue", { required: true })
    model!: readonly number[];

    @Prop({ type: Array, required: true })
    options!: EnumeratorFilterItemDto[];

    /**
     * Block dropdown when no options provided.
     */
    @Prop({ default: true, type: Boolean })
    blockEmpty!: boolean;

    /**
     * Block dropdown when single item provided in the options.
     */
    @Prop({ default: false, type: Boolean })
    blockSingle!: boolean;

    showTail = false;

    get optionsHead(): EnumeratorFilterItemDto[] {
        return this.options.slice(0, 5);
    }

    get optionsTail(): EnumeratorFilterItemDto[] {
        return this.options.slice(5);
    }

    get blocked() {
        return (
            (!this.options.length && this.blockEmpty) ||
            (this.options.length <= 1 && this.blockSingle)
        );
    }

    @Emit("blocked")
    emitBlocked() {
        return this.blocked;
    }

    mounted() {
        watchEffect(() => {
            this.emitBlocked();
        });
    }

    toggleTail(value = !this.showTail) {
        this.showTail = value;
    }

    isOptionSelected(option: EnumeratorFilterItemDto) {
        return this.model.includes(option.id);
    }

    toggleOption(
        option: EnumeratorFilterItemDto,
        value = !this.isOptionSelected(option),
    ): void {
        if (value && !this.isOptionSelected(option)) {
            this.model = [...this.model, option.id];
        }

        if (!value && this.isOptionSelected(option)) {
            this.model = eff.fn.pipe(
                this.model,
                eff.array.filter((it) => it !== option.id),
            );
        }
    }
}
